const Pact = require("../../entities/Pact");
const { Age }  = require("../Constants");
const PactNames = require("../Names/PactNames");


class AcceptanceOfSupremacy extends Pact {
    constructor() {
        super(
            Age.Age2,
            PactNames.AcceptanceOfSupremacy,
            "The Two civilizations cannot attack each other. Each round, A produces an extra resource and B produces on resource less.",
            {}
        )
    }
}

module.exports = AcceptanceOfSupremacy;